import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { InstanceEffects } from './effects/instance.effects';
import * as InstanceReducer from './reducers/instance.reducer';
import { InstanceService } from './services/instance.service';
import { InstanceStoreFacade } from './facades/instance-store.facade';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      InstanceReducer.instanceFeatureKey,
      InstanceReducer.reducer
    ),
    EffectsModule.forFeature([InstanceEffects]),
  ],
  providers: [InstanceService, InstanceStoreFacade],
})
export class InstancesStoreModule {}
